"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderStringWithHTML = exports.phoneNumber = exports.emailValidation = void 0;
var react_1 = __importDefault(require("react"));
var emailValidation = function (email) {
    var regexPattern = /^\w+([\.\+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
    if (regexPattern.test(email)) {
        return (true);
    }
    else {
        return (false);
    }
};
exports.emailValidation = emailValidation;
var phoneNumber = function (to) {
    var number = to ? to.replace(/\D/g, "") : "";
    if (number) {
        if (number.length === 10) {
            number = "+1" + number;
        }
        else if (number.length === 7) {
            number = "+1206" + number;
        }
        else if (number.length > 10) {
            if (number.charAt(0) !== "1") {
                number = "+1" + number;
            }
            else {
                number = "+" + number;
            }
            if (number.length > 12) {
                number = number.substr(0, 12);
            }
        }
        else {
            number = "";
        }
    }
    return number;
};
exports.phoneNumber = phoneNumber;
var renderStringWithHTML = function (rawHTML) {
    return react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: rawHTML } });
};
exports.renderStringWithHTML = renderStringWithHTML;
